module.exports = __webpack_public_path__ + "static/media/sense4156.6102379e.jpg";